class SiteElementCollapsable extends QueryElement<HTMLElement> {
  private _actors: IQueryElement[];

  constructor(card: ISiteCard, element: HTMLElement) {
    super(element, false);

    // Find all actor buttons within this collapsable element
    this._actors = this.query("[data-type='collapsable-actor']").all((a) => {
      a.on("click", (e: Event) => {
        this.toggle();
      });

      return a;
    });
  }

  private toggle(): void {
    if (this.containsClass("expand")) {
      this.removeClass("expand");
    } else {
      this.addClass("expand");
    }
  }
}
